const ecoSystem: string = process.env.REACT_APP_ECO_SYSTEM || "";

export const getUserSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/+/user/${localStorage.getItem("RID")}/+`;
};

export const getPageFocusSubscriptionTopic = (): string => {
  return `${ecoSystem}/user/${localStorage.getItem("RID")}/page/+/focusPage`;
};

export const getPagesSubscriptionTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/searchPage/reply`;
};

export const getPagesRequestPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/searchPage`;
};

export const getUserUpdatedTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/user/${localStorage.getItem(
    "RID"
  )}/eventPageUpdated`;
};

export const connectPageRequestPublishTopic = () => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/connectPage`;
};

export const disconnectPageRequestPublishTopic = () => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/disconnectPage`;
};

export const getPageRequestPublishTopic = () => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/searchInPage`;
};

export const getPageSubscriptionTopic = () => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/searchInPage/reply`;
};

export const getCreatePagePublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/createPage`;
};

export const getCreatePageSubscriptionTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/createPage/reply`;
};

export const updatePagePublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/updatePage`;
};

export const getUpdatePageSubscriptionTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/live/updatePage/reply`;
};

export const getCLBSLocations = (): string => {
  return `get/places`;
};

export const getTwilioTokenSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/connection/${localStorage.getItem(
    "CID"
  )}/getTokenResult`;
};

export const getProjectsSubscriptionTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/dps/getProjects/reply`;
};

export const getProjectsRequestPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/dps/getProjects`;
};

export const getSendAssistLinkPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/dps/sendAssistPageLink`;
};

export const getTwilioTokenPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/twilio/getToken`;
};

export const getTwilioJoinRoomSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/connection/${localStorage.getItem(
    "CID"
  )}/joinRoomResult`;
};

export const getTwilioJoinRoomPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/twilio/joinRoom`;
};

export const getTwilioLeaveRoomSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/connection/${localStorage.getItem(
    "CID"
  )}/leaveRoomResult`;
};

export const getTwilioLeaveRoomPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/twilio/leaveRoom`;
};

export const getTwilioSaveVideoRecordingSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/connection/${localStorage.getItem(
    "CID"
  )}/saveRecordingResult`;
};

export const getTwilioSaveVideoRecordingPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/twilio/saveRecording`;
};

export const getTwilioRecordedVideoSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/connection/${localStorage.getItem(
    "CID"
  )}/recordingMediaResult`;
};

export const getTwilioRecordedVideoRecordingPublishTopic = (): string => {
  return `${ecoSystem}/connection/${localStorage.getItem(
    "CID"
  )}/service/twilio/recordingMedia`;
};

export const getTwilioVideoJoinSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/user/${localStorage.getItem(
    "RID"
  )}/videoJoin`;
};

export const getTwilioVideoLeftSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/user/${localStorage.getItem(
    "RID"
  )}/videoLeft`;
};

export const getTwilioVideoEndSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/user/${localStorage.getItem(
    "RID"
  )}/videoEnd`;
};

export const getTwilioSaveRecordingSubscriptionTopic = (): string => {
  return `${ecoSystem}/service/twilio/user/${localStorage.getItem(
    "RID"
  )}/saveRecording`;
};

export const getMembersPageCreatedPublishTopic = (memberId: string): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/user/${memberId}/eventPageCreated`;
};

export const getMemberPageUpdatedPublishTopic = (memberId: string): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/user/${memberId}/eventPageUpdated`;
};

export const getMembersRemoveFromPagePublishTopic = (
  memberId: string
): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/user/${memberId}/eventPageRemoved`;
};

export const getPageTypingSubscriptionTopic = (pageId: number): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/page/${pageId}/connection/+/pageTyping`;
};

// TODO: fix ecosystem name
export const getModifyPageSubscriptionTopic = (pageId: number): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/page/${pageId}/modifyPage`;
};

// TODO: fix ecosystem name
export const getSearchMessageSubscriptionTopic = (pageId: number): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/page/${pageId}/searchMessage/reply`;
};

// TODO: fix ecosystem name
export const getSearchMessagePublishTopic = (pageId: number): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/page/${pageId}/searchMessage`;
};

export const getCreateMessagePublishTopic = (pageId: number): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/page/${pageId}/createMessage`;
};

export const getCreateEventPagePublishTopic = (
  connectionId: string
): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/createEventPage`;
};


export const inviteExternalUsersTopic = (): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    "CID"
  )}/service/react-api/inviteExternalUsers`;
};